import { LocalizedRichDescription } from '../models/serializable/localized-rich-description.js';
import { LocalizedString } from '../models/serializable/localized-string.js';

export abstract class IDataWithLocalizedName {
  abstract get names(): LocalizedString;
}

export abstract class IDataWithLocalizedDescription {
  abstract get descriptions(): LocalizedString
}

export abstract class IDataWithLocalizedRichDescription {
  abstract get richDescriptions(): LocalizedRichDescription
}

export abstract class IDataWithLocalizedTitle {
  abstract get titles(): LocalizedString
}
